import { Injectable } from '@angular/core';
import { LeaApiService } from './lea-api.service';

@Injectable()
export class DynamiclinkService {

  constructor(
		private _rest: LeaApiService) { }

    public getDriverList(){
      return this._rest.get('admin/drivers');
    }
}
